/**
 * A centralized handler the app can use to show and track all possible errors.
 *
 * @todo This is WIP yet; the idea is to integrate it with an events system in order to be able
 *       to hook notifications.
 */
class AppErrorHandler {
  /**
   * @param {AppLogger} appLogger To log the errors.
   */
  constructor(appLogger) {
    'inject';

    /**
     * A local reference for the `appLogger` service.
     * @type {AppLogger}
     * @access protected
     */
    this._appLogger = appLogger;
  }
  /**
   * This is the _"main method"_ of the class: It takes care of handling exceptions.
   * @param {Error|Object|string} error              The error exception the method needs to
   *                                                 handle.
   * @param {string}              [customMessage=''] A custom message to overwrite the one on the
   *                                                 exception.
   * @param {boolean}             [silent=false]     Whether or not the rest of the app should be
   *                                                 make aware of the error.
   */
  handle(error, customMessage = '', silent = false) {
    if (!silent) {
      const message = customMessage || error.message || 'Unexpected error';
      this._appLogger.error(message);
    }

    if (error instanceof Error) {
      this._appLogger.error(error);
    }
  }
  /**
   * Tells the service to handle the error without notifying the rest of the app. The idea of this
   * method is for it to be used in cases when the error is possibly expected and it wouldn't
   * affect the app.
   * @param {Error|Object|string} error The error exception the method needs to handle.
   */
  silent(error) {
    this.handle(error, '', true);
  }
}

export { AppErrorHandler };
